import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends WizardHpBaseComponent implements OnInit  {
  infos: any;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {

    super(chgDetectorRef, hpService, router);
    this.getHpService().setHeaderIn(false);
  }

  ngOnInit() {

  }

  toSimuleo() {
    this.getHpService().setImageName("203");
    this.getHpService().setHeaderIn(true);
    this.getHpService().setIsUploadExt(false);
    this.getHpService().setTypeVisuel('view-0')
    this.getHpService().setView("0");
    this.getHpService().emitDataChange();
    this.getRouter().navigate(['simulateur-de-portes']);
  }

}
